import styled from '@emotion/styled'

export const Container = styled.div<{ isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid ${({ isActive }) => (isActive ? '#77778E' : '#D2D2D9')};
  background: #fafafb;
`
